var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_26_xA0_Bild_1_",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "389px",
    height: "36px",
    viewBox: "-9 -10.5 389 36",
    enableBackground: "new -9 -10.5 389 36",
    xmlSpace: "preserve",
    className: "ng-scope",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_gross_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9.5,
    className: "foreground",
    fill: "#EDEDED",
    width: 16,
    height: 16
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_gross_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9,
    y: 9.5,
    className: "foreground",
    fill: "#EDEDED",
    width: 16,
    height: 16
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_klein_5_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: -1.5,
    className: "foreground",
    fill: "#EDEDED",
    width: 7,
    height: 7
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_klein_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: -10.5,
    className: "foreground",
    fill: "#EDEDED",
    width: 7,
    height: 7
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_klein_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: -1.5,
    className: "foreground",
    fill: "#EDEDED",
    width: 7,
    height: 7
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_klein_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: -10.5,
    className: "foreground",
    fill: "#EDEDED",
    width: 7,
    height: 7
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_gross"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -9,
    y: -10.5,
    className: "foreground",
    fill: "#EDEDED",
    width: 16,
    height: 16
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#EDEDED",
    d: "M55.751,25.602C48.5,25.602,43,20.65,43,13.301v-23.602h5.4v23.352c0,4.75,2.9,7.7,7.351,7.7 s7.401-2.95,7.401-7.7v-23.352h5.399v23.602C68.551,20.65,63.001,25.602,55.751,25.602z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#EDEDED",
    d: "M94.451,25.301l-7.501-15H80.2v15h-5.4v-35.602H88.6c6.75,0,11.051,4.35,11.051,10.4 c0,5.101-3.101,8.351-7.101,9.451l8.2,15.75H94.451z M88.2-5.451h-8V5.7h8c3.601,0,6.051-2.05,6.051-5.55 C94.25-3.351,91.8-5.451,88.2-5.451z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#EDEDED",
    d: "M119.449,25.301h-14.4v-35.602H118.9c6.6,0,10.75,3.75,10.75,9.75c0,3.85-2.4,6.601-4.801,7.55 c2.752,1.1,5.352,3.75,5.352,8.25C130.201,21.801,125.75,25.301,119.449,25.301z M118.449-5.451h-8V4.75h8 c3.451,0,5.801-1.8,5.801-5.1C124.25-3.65,121.9-5.451,118.449-5.451z M118.949,9.6h-8.5v10.851h8.5 c3.752,0,5.852-2.301,5.852-5.451C124.801,11.851,122.701,9.6,118.949,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#EDEDED",
    d: "M156.15,25.301l-2.449-7.15H139.65l-2.451,7.15h-5.75L144.5-10.301h4.35L161.9,25.301H156.15z  M146.801-2.25l-5.551,15.801h10.951L146.801-2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#EDEDED",
    d: "M186.301,25.301L169.85,0.25v25.051h-5.4v-35.602h4.951l16.451,25.002v-25.002h5.4v35.602H186.301z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "accent",
    fill: "#BED600",
    d: "M209.549,25.602c-3.699,0-6.9-1.351-9.35-3.801c-3.502-3.5-3.451-7.45-3.451-14.301 c0-6.85-0.051-10.8,3.451-14.301c2.449-2.45,5.65-3.8,9.35-3.8C216.1-10.601,221-6.75,222.25,0.35h-5.5 c-0.852-3.6-3.25-6.1-7.201-6.1c-2.1,0-4,0.8-5.25,2.15c-1.75,1.9-2.15,3.95-2.15,11.101s0.4,9.201,2.15,11.102 c1.25,1.35,3.15,2.149,5.25,2.149c3.951,0,6.4-2.5,7.25-6.101h5.451C221.049,21.751,216,25.602,209.549,25.602z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "accent",
    fill: "#BED600",
    d: "M247.85,21.801c-2.451,2.45-5.602,3.801-9.4,3.801c-3.801,0-6.9-1.351-9.352-3.801 c-3.5-3.5-3.449-7.45-3.449-14.301c0-6.85-0.051-10.8,3.449-14.301c2.451-2.45,5.551-3.8,9.352-3.8c3.799,0,6.949,1.35,9.4,3.8 c3.5,3.5,3.4,7.451,3.4,14.301C251.25,14.351,251.35,18.301,247.85,21.801z M243.748-3.55c-1.25-1.35-3.199-2.2-5.299-2.2 c-2.102,0-4.051,0.85-5.301,2.2c-1.75,1.9-2.1,3.9-2.1,11.05s0.35,9.15,2.1,11.051c1.25,1.35,3.199,2.2,5.301,2.2 c2.1,0,4.049-0.851,5.299-2.2c1.75-1.9,2.102-3.9,2.102-11.051S245.498-1.65,243.748-3.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "accent",
    fill: "#BED600",
    d: "M268.248,25.602c-3.699,0-6.9-1.351-9.35-3.801c-3.502-3.5-3.451-7.45-3.451-14.301 c0-6.85-0.051-10.8,3.451-14.301c2.449-2.45,5.65-3.8,9.35-3.8c6.551,0,11.451,3.851,12.701,10.951h-5.5 c-0.852-3.6-3.25-6.1-7.201-6.1c-2.1,0-4,0.8-5.25,2.15c-1.75,1.9-2.15,3.95-2.15,11.101s0.4,9.201,2.15,11.102 c1.25,1.35,3.15,2.149,5.25,2.149c3.951,0,6.4-2.5,7.25-6.101h5.451C279.748,21.751,274.699,25.602,268.248,25.602z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "accent",
    fill: "#BED600",
    d: "M307.049,25.301l-10-17.551l-6,7.201v10.35h-5.4v-35.602h5.4V7.6L305.6-10.301h6.6L300.648,3.65 L313.4,25.301H307.049z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "accent",
    fill: "#BED600",
    d: "M329.549,11.301h-8.102v14h-5.4v-35.602h13.502c6.949,0,11.4,4.6,11.4,10.8 C340.949,6.7,336.498,11.301,329.549,11.301z M329.248-5.451h-7.801V6.4h7.801c3.75,0,6.301-2.15,6.301-5.9 C335.549-3.25,332.998-5.451,329.248-5.451z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "accent",
    fill: "#BED600",
    d: "M344.996,25.301v-35.602h5.4v35.602H344.996z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "accent",
    fill: "#BED600",
    d: "M369.248-5.451v30.751h-5.4V-5.451h-9.801v-4.85h25.002v4.85H369.248z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.1f22cbdd37c6d78c9201be70430999aa.svg";
export { ForwardRef as ReactComponent };